module.exports = __webpack_public_path__ + "img/couples_17_V.e795c188.webp";